<template>
    <section 
    v-if="this.$localStorage.get(this.$store.storeName) == null"
    class="md:h-screen py-36 flex
     items-center bg-orange-500/10 dark:bg-orange-500/20 
     bg-[url('../../theme8/images/hero/bg-shape.png')] bg-center 
     bg-no-repeat bg-cover"
     style="margin-top:8% !important"
     >
            <div class="container relative" >
                <div class="grid grid-cols-1">
                    <div class="relative overflow-hidden rounded-md shadow
                     dark:shadow-gray-700 bg-white dark:bg-slate-900">
                        <div class="grid md:grid-cols-2 grid-cols-1 items-center">
                            <div class="relative md:shrink-0 login_img">
                                <img class="lg:h-full h-full w-full
                                 object-cover md:h-[34rem]" 
                                 :src="this.$store.state.logo_footer"
                                  alt="">
                            </div>

                            <div class="p-8 lg:px-20">
                                <div class="text-center">
                                    <router-link :to="{
                                      name: 'home',
                                      params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                                    }">
                                    </router-link>
                                </div>
                                <div v-if="errorMessage != ''" 
                                style="text-align: center; color: red; padding: 5px">
                                    <p style="margin: 0">{{ errorMessage }}</p>
                                </div>

                                <form  
                                @submit.prevent="submitInfo"
                                @keydown="form.onKeydown($event)"
                                class="text-start lg:py-20 py-8">
                                    <div class="grid grid-cols-1">
                                        <div class="mb-4">
                                            <label 
                                            class="font-semibold" 
                                            for="Loginphone">
                                            {{ $t('Phone') }}:</label>
                                            <input id="Loginphone" 
                                            type="text" 
                                            class="mt-3 w-full py-2 px-3 
                                            h-10 bg-transparent dark:bg-slate-900
                                             dark:text-slate-200 rounded outline-none
                                              border border-gray-100 dark:border-gray-800 
                                              focus:ring-0" 
                                            v-model="form.basic_phone"
                                            placeholder="xxxx xxxx"
                                            required
                                            :minlength="$store.state.country_length"
                                            :maxlength="$store.state.country_length"
                                            style="text-align:center"
                                             >
                                             <span class="flag">  
                                                <h2>{{ $store.state.country_code }}</h2>
                                                <img :src="this.$store.state.country_flag" />
                                             </span>
                                        </div>
        
                                        <div class="mb-4">
                                            <label 
                                            class="font-semibold" 
                                            for="LoginPassword"
                                            >{{ $t('password') }}:</label>
                                            <input 
                                            id="LoginPassword" 
                                            type="password" 
                                            class="mt-3 w-full py-2 
                                            px-3 h-10 bg-transparent 
                                            dark:bg-slate-900 dark:text-slate-200 
                                            rounded outline-none border border-gray-100
                                             dark:border-gray-800 focus:ring-0" 
                                             v-model="form.password"
                                             :placeholder="$t('EnterPass')"
                                             required
                                             minlength="8"
                                             >
                                        </div>
        
                                        <div class="flex justify-between mb-4">
                                            <div class="flex items-center mb-0">
                                                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2" type="checkbox" value="" id="RememberMe">
                                                <label class="form-checkbox-label text-slate-400" for="RememberMe">{{ $t('Remember me') }}</label>
                                            </div>
                                            
                                            <p class="text-slate-400 mb-0">
                                            <a class="text-slate-400 cursor-pointer"
                                             @click="(forgetVodal = true), (phone = null), (partphone = null)"
                                             >{{$t('forgetpass')}}</a></p>
                                        </div>
        
                                        <div class="mb-4">
                                            <input type="submit" :disabled="form.busy || googleLoading || appleLoading"
                                             class="py-2 px-5 inline-block tracking-wide
                                              align-middle duration-500 text-base text-center
                                               bg-orange-500 text-white rounded-md w-full cursor-pointer disabled:opacity-50" 
                                               :value="$t('logIn')">
                                        </div>
                                             <div class="login">
                                        <!-- فاصل أو (Or) -->
                                        <div class="relative flex py-2 items-center justify-center my-2">
                                            <div class="w-1/4 border-t border-gray-200 dark:border-gray-700"></div>
                                            <span class="mx-3 text-gray-400 text-sm">{{ $t('or') }}</span>
                                            <div class="w-1/4 border-t border-gray-200 dark:border-gray-700"></div>
                                        </div>

                                        <!-- أزرار تسجيل الدخول بواسطة جوجل وآبل -->
                                        <div class="flex flex-row items-center justify-between gap-3 w-full mt-2">
                                            <button 
                                                type="button"
                                                @click="triggerGoogleLogin"
                                                :disabled="loading || googleLoading || appleLoading"
                                                class="w-1/2 w-full h-11 flex items-center justify-center gap-2 bg-white hover:bg-gray-50 dark:bg-transparent dark:hover:bg-slate-800 text-gray-700 dark:text-gray-200 rounded-md border border-gray-300 dark:border-gray-700 font-medium text-sm shadow-sm transition-all duration-300 active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed"
                                            >
                                                <svg v-if="!googleLoading" class="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
                                                    <path fill="#EA4335" d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582l3.51-3.51C17.742 1.054 15.01 0 12 0 7.354 0 3.31 2.697 1.345 6.643l3.92 3.122z"/>
                                                    <path fill="#4285F4" d="M23.49 12.275c0-.826-.074-1.62-.21-2.386H12v4.512h6.446a5.51 5.51 0 0 1-2.39 3.613l3.722 2.885c2.177-2.005 3.432-4.957 3.432-8.624z"/>
                                                    <path fill="#FBBC05" d="M5.266 14.235A7.086 7.086 0 0 1 4.909 12c0-.783.128-1.536.357-2.235L1.345 6.643A11.932 11.932 0 0 0 0 12c0 1.923.455 3.74 1.26 5.357l4.006-3.122z"/>
                                                    <path fill="#34A853" d="M12 24c3.24 0 5.957-1.075 7.942-2.914l-3.722-2.885c-1.03.69-2.347 1.103-4.22 1.103-3.834 0-7.078-2.593-8.236-6.082l-4.006 3.122A11.942 11.942 0 0 0 12 24z"/>
                                                </svg>
                                                <i v-else class="mdi mdi-loading mdi-spin w-5 h-5 text-gray-500 text-lg flex items-center justify-center"></i>
                                                <span class="truncate"> {{$t('google')}}</span>
                                            </button>

                                            <button 
                                                type="button"
                                                @click="triggerAppleLogin"
                                                :disabled="loading || googleLoading || appleLoading"
                                                class="w-1/2 w-full h-11 flex items-center justify-center gap-2 bg-black hover:bg-neutral-900 dark:bg-white dark:hover:bg-gray-100 text-white dark:text-black rounded-md font-medium text-sm transition-all duration-300 active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed shadow-sm"
                                            >
                                                <svg v-if="!appleLoading" class="w-5 h-5 fill-current flex-shrink-0" viewBox="0 0 24 24">
                                                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 4.17c.66-.81 1.11-1.93.99-3.06-1 .04-2.21.67-2.93 1.49-.62.69-1.16 1.84-1.01 2.96 1.1.09 2.23-.58 2.95-1.39z"/>
                                                </svg>
                                                <i v-else class="mdi mdi-loading mdi-spin w-5 h-5 text-current text-lg flex items-center justify-center"></i>
                                                <span class="truncate" style="color:black"> {{$t('apple')}}</span>
                                            </button>
                                        </div>
                                        </div>

                                        <div v-if="loading==true" class="text-center mt-4">
                                             loading.....
                                        </div>

                                        <div class="text-center mt-4">
                                            <span class="text-slate-400 me-2">
                                                {{ $t("dontHaveAccount") }}</span> 
                                                <router-link
                                                 :to="{
                                                 name: 'register',
                                                 params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
                                               }"
                                        class="text-black dark:text-white font-bold inline-block">{{$t('signup')}}</router-link>
                                        </div>
                                    </div>
                                </form>
                                
                                <div v-if="loading" class="empty text-center center-text">
                                     <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                                     <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- مودال نسيت كلمة المرور -->
            <vodal
              :show="forgetVodal"
              animation="flip"
              @hide="forgetVodal = false"
              style="margin-top: 20px"
            >
              <div class="container" >
                  <div class="mb-4">
                        <label class="font-semibold" for="passphone">
                        {{ $t('Phone') }}:</label>
                        <input id="passphone" 
                        type="text" 
                        class="mt-3 w-full py-2 px-3 
                        h-10 bg-transparent dark:bg-slate-900
                         dark:text-slate-200 rounded outline-none
                          border border-gray-100 dark:border-gray-800 
                          focus:ring-0" 
                          v-model="passphone_basic"
                          placeholder="xxxx xxxx"
                          required
                          :minlength="$store.state.country_length"
                          :maxlength="$store.state.country_length"
                          style="text-align:center"
                         >
                         <span class="flag">  
                            <h2>{{ $store.state.country_code }}</h2>
                            <img :src="this.$store.state.country_flag" />
                         </span>
                  </div>

                <button class="py-2 px-5 inline-block tracking-wide
                                  align-middle duration-500 text-base text-center
                                   bg-orange-500 text-white rounded-md w-full"
                                    @click="resetpass()">{{ $t("continue") }}</button>
                <p style="text-align: center">{{ errorMessageVodal }}</p>
                <br>
                <p @click="forgetEmail()" class="forget_user_name" style="cursor:pointer">{{ $t("forget user name") }}</p>
                <div v-if="loading" class="empty text-center center-text">
                     <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                     <br>
                </div>
              </div>
            </vodal>

            <!-- مودال تواصل معنا -->
            <vodal
              :show="forgetEmailVodal"
              animation="slideLeft"
              @hide="forgetEmailVodal = false"
              style="margin-top: 20px"
            >
              <div class="container" >
                <h5 style="color: var(--primary-color);text-align:center">{{ $t("contactUs") }}</h5>
                <div dir="ltr" class="text-center" style="margin-top:10px">
                  <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+this.$store.state.phone+'&text=Hello!'">
                    <h5><i class="bi bi-telephone-fill"></i> {{ this.$store.state.phone }}</h5>
                  </a>
                  <a target="_blank" :href="'mailto:'+  this.$store.state.email">
                    <h5 style="margin-top:20px"><i class="bi bi-envelope-fill"></i> {{ this.$store.state.email }}</h5>
                  </a>
                </div>
               
                <p style="text-align: center">{{ errorMessageVodal }}</p>
                <div v-if="loading" class="empty text-center center-text">
                     <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                     <br>
                </div>
              </div>
            </vodal>

            <!-- مودال إدخال الكود -->
            <vodal
              :show="codeVodal"
              animation="slideLeft"
              @hide="codeVodal = false"
              style="margin-top: 20px"
            >
              <div class="container">
                <h5 style="color: var(--primary-color); text-align:center;">{{ $t("EntertheCode") }} :</h5>
                <div dir="ltr" class="mt-5">
                  <CodeInput
                    :loading="false"
                    required
                    class="input"
                    @change="onChange"
                    @complete="onComplete"
                  />
                  <p style="margin-top: 10px; margin-bottom: 0; text-align: center;" v-if="$i18n.locale == 'en'">{{ countDown }} second</p>
                  <p style="margin-top: 10px; margin-bottom: 0; text-align: center;" v-else>{{ countDown }} ثانية</p>
                </div>
                <button
                  v-if="countDown == 0"
                  class="ResendCode py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                  @click="ResendCode()"
                >{{ $t("ResendCode") }}</button>
                <br>
                <button
                  class="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                  @click="checkCode()"
                  :disabled="countDown == 0"
                >{{ $t("continue") }}</button>
                <p style="text-align: center; margin-top: 10px">{{ errorMessageVodal }}</p>
                <div v-if="loading" class="empty text-center center-text">
                     <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                     <br>
                </div>
              </div>
            </vodal>

            <!-- مودال كلمة المرور الجديدة -->
            <vodal
              :show="newPassVodal"
              animation="slideLeft"
              @hide="newPassVodal = false"
              style="margin-top: 20px"
            >
              <div class="container">
                <h5 style="color: var(--primary-color); text-align: center;">{{ $t("EnterNewPass") }} :</h5>
                
                <div class="mb-4">
                    <label class="font-semibold" for="passPassword"></label>
                    <input 
                    id="passPassword" 
                    type="password" 
                    class="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" 
                    v-model="Newpassword"
                    :placeholder="$t('EnterPass')"
                    required
                    minlength="8"
                    >
                </div>
                <button class="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                        @click="SaveChanges()">{{ $t("SaveChanges") }}</button>
                <p style="text-align: center; margin-top: 10px">{{ errorMessageVodal }}</p>
                <div v-if="loading" class="empty text-center center-text">
                     <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif"/>
                     <br>
                </div>
              </div>
            </vodal>
    </section>
</template>

<script>
import Form from "vform";
import { AlertErrors, AlertSuccess } from "vform/src/components/bootstrap5";
import CodeInput from "vue-verification-code-input";
import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";
import "vodal/slide-left.css";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    AlertErrors,
    AlertSuccess,
    Vodal,
    CodeInput,
    VuePhoneNumberInput,
  },
  data: function() {
    return {
      googleLoading: false, 
      appleLoading: false,  
      forgetVodal: false,
      forgetEmailVodal: false,
      codeVodal: false,
      newPassVodal: false,
      DBitems: null,
      errorMessageVodal: "",
      errorMessage: "",
      passemail: "",
      passphone_basic: null,
      Newpassword: null,
      checkcomplete: false,
      validateMessage: "",
      finalcode: null,
      loading: false,
      form: new Form({
        email: null,
        password: null,
        fsm_token: this.$store.state.fsm_token,
        phone: null,
        basic_phone: null,
        country_code: this.$store.state.country_code,
      }),
      isValid: false,
      partphone: null,
      phone: null,
      emailTrue: false,
      countDown: 90
    };
  },
  created() {
    this.$store.state.topbar = 'topbar_dark';
    this.$store.state.navbar = 'navbar_dark navbar_top';

    this.loading = true;
    if (this.$localStorage.get(this.$store.storeName) != null) {
      this.$router.push({
        name: "home1",
        params: { storeName: this.$store.storeName, lang: this.$i18n.locale }
      });
    }
    this.loading = false;
    if (this.$i18n.locale == 'ar') {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content = this.$store.state.description_ar;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
    } else {
      document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content = this.$store.state.description_en;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
    }
  },
  mounted() {
    this.initGoogleClient();
    this.initAppleSignIn();

    // الاستماع للبيانات القادمة من النافذة المنبثقة لآبل دون مغادرة Vue
    window.addEventListener("message", this.handleApplePopupMessage);

    try {
      if (this.$i18n.locale == "ar") {
        document.getElementsByClassName("input-tel__input")[0].setAttribute("placeholder", "رقم الهاتف");
        document.getElementsByClassName("country-selector__label")[0].innerHTML = "رمز الدولة";
        document.getElementsByClassName("input-tel__label")[0].innerHTML = "* رقم الهاتف";
      }
    } catch (e) {}
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleApplePopupMessage);
  },
  methods: {
    initGoogleClient() {
      if (typeof google !== 'undefined') {
        google.accounts.id.initialize({
          client_id: "481057305498-gi99qofkpferfklfir3otllmgte9q8kp.apps.googleusercontent.com", 
          callback: this.handleGoogleResponse
        });
      } else {
        setTimeout(this.initGoogleClient, 1000);
      }
    },

    triggerGoogleLogin() {
      if (typeof google !== 'undefined') {
        this.googleLoading = true; 
        google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                this.googleLoading = false; 
            }
        });
      }
    },

    async handleGoogleResponse(response) {
      this.googleLoading = true;
      try {
        const base64Url = response.credential.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        
        const googleUser = JSON.parse(jsonPayload);

        const formData = new FormData();
        formData.append('google_id', googleUser.sub);
        formData.append('email', googleUser.email);
        formData.append('name', googleUser.name || '');
        if (this.form.fsm_token) {
          formData.append('fsm_token', this.form.fsm_token);
        }

        const apiUrl = `${this.$store.state.base_api_url}${this.$store.storeName}/auth/google/login`;
        const res = await this.axios.post(apiUrl, formData, {
          headers: { 
            "Accept-Language": this.$i18n.locale,
            "Content-Type": "multipart/form-data"
          }
        });

        this.processSocialLoginSuccess(res.data);
      } catch (error) {
        this.handleSocialError(error);
      } finally {
        this.googleLoading = false;
      }
    },

    initAppleSignIn() {
      if (typeof AppleID !== 'undefined') {
        AppleID.auth.init({
          clientId: 'com.etrolly.gameoutstore.web', 
          scope: 'name email',
          redirectURI: 'https://etrolley.net/apple/outgamestore/callback', 
          state: 'origin_state',
          usePopup: true,          
          responseMode: 'form_post'
        });
      } else {
        setTimeout(this.initAppleSignIn, 1000);
      }
    },

    triggerAppleLogin() {
      if (typeof AppleID !== 'undefined') {
        this.appleLoading = true;
        AppleID.auth.signIn();
      }
    },

    handleApplePopupMessage(event) {
      if (event.data && event.data.type === 'APPLE_LOGIN_RESPONSE') {
        const responseData = event.data.data;
        
        if (responseData.status === 'success') {
          this.$localStorage.set(this.$store.storeName, responseData.token);
          this.$localStorage.set(this.$store.user_name, responseData.name);
          
          this.$router.push({
            name: "home",
            params: { storeName: this.$store.storeName, lang: this.$i18n.locale }
          }).then(() => {
             window.location.reload();
          });
        } else {
          this.appleLoading = false;
          this.errorMessage = this.$i18n.locale == 'en' ? "Apple Authentication failed" : "فشلت عملية التحقق بواسطة آبل";
          setTimeout(() => { this.errorMessage = ""; }, 5000);
        }
      }
    },

    processSocialLoginSuccess(data) {
      if (data.code == "1") {
        this.$localStorage.set(this.$store.storeName, data.data.token);
        this.$localStorage.set(this.$store.user_name, data.data.name);
        window.location.href = "/";
      } else {
        this.errorMessage = data.message || "Error occurred";
        setTimeout(() => { this.errorMessage = ""; }, 4000);
      }
    },

    handleSocialError(error) {
      if (error.response && error.response.data && error.response.data.message) {
        this.errorMessage = error.response.data.message;
      } else if (error.message) {
        this.errorMessage = error.message;
      } else {
        this.errorMessage = this.$i18n.locale == 'en' ? "Authentication failed" : "فشلت عملية التحقق";
      }
      setTimeout(() => { this.errorMessage = ""; }, 5000);
    },

    async submitInfo() {
      this.loading = true;
      this.form.phone = this.form.country_code + this.form.basic_phone;

      await this.form
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/login",
          {
            phone: this.form.phone,
            password: this.form.password,
            fsm_token: this.form.fsm_token,
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.loading = false;
          if (response.data.code == "1") {
            this.$localStorage.set(
              this.$store.storeName,
              response.data.data.token
            );

            this.$localStorage.set(
              this.$store.user_name,
              response.data.data.name
            );
            if (!response.data.data.name || response.data.data.name == '') {
              this.$localStorage.set(
                this.$store.user_name,
                this.form.phone 
              );
            }
            window.location.href = "/";
          } else if (response.data.code == "-1") {
            this.form.basic_phone = null;
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = response.data.error;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        });
    },
    forgetEmail() {
      this.forgetVodal = false;
      this.forgetEmailVodal = true;
      this.passemail = null;
    },
    sendPhone1(event) {
      this.isValid = event.isValid;
      if (this.isValid == true) {
        this.phone = event.e164;
      }
    },
    resetpass() {
      this.loading = true;
      this.passphone = this.$store.state.country_code + this.passphone_basic;
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/forget_password",
          {
            phone: this.passphone
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.loading = false;
          if (response.data.code == "1") {
            this.forgetVodal = false;
            this.forgetEmailVodal = false;
            this.codeVodal = true;
            this.emailTrue = true;
            this.countDown = 120;
            this.countDownTimer();
          } else if (response.data.code == "-1") {
            this.errorMessageVodal = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessageVodal = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          }
        });
    },
    checkCode() {
      this.loading = true;
      if (this.checkcomplete == true) {
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/verivey_reset_password",
            {
              code: this.finalcode,
              phone: this.passphone
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            this.loading = false;
            if (response.data.code == "1") {
              this.forgetVodal = false;
              this.forgetEmailVodal = false;
              this.codeVodal = false;
              this.newPassVodal = true;
            } else if (response.data.code == "-1") {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
            if (response.data.error) {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
          });
      } else {
        this.loading = false;
        if (this.$i18n.locale == "en") {
          this.errorMessageVodal = "your code isn't complete";
          setTimeout(() => {
            this.errorMessageVodal = "";
          }, 3000);
        } else {
          this.errorMessageVodal = "الرمز المدخل غير مكتمل";
          setTimeout(() => {
            this.errorMessageVodal = "";
          }, 3000);
        }
      }
    },
    SaveChanges() {
      this.loading = true;
      if (this.Newpassword != null) {
        this.passphone = this.$store.state.country_code + this.passphone_basic;

        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/update_password",
            {
              password: this.Newpassword,
              email: this.passemail,
              phone: this.passphone,
              fsm_token: this.form.fsm_token
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            this.loading = false;
            if (response.data.code == "1") {
              this.forgetVodal = false;
              this.forgetEmailVodal = false;
              this.codeVodal = false;
              this.newPassVodal = false;

              this.$localStorage.set(
                this.$store.storeName,
                response.data.data.token
              );
              window.location.href = "/profile";
            } else if (response.data.code == "-1") {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
            if (response.data.error) {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
          });
      } else {
        this.loading = false;
        this.errorMessageVodal = "error";
        setTimeout(() => {
          this.errorMessageVodal = "";
        }, 3000);
      }
    },
    ResendCode() {
      this.loading = true;
      let val = {};
      if (this.emailTrue == true) {
        val = { email: this.passemail };
      } else {
        val = { phone: this.passphone };
      }
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/forget_password",
          val,
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.loading = false;
          if (response.data.code == "-1") {
            this.errorMessageVodal = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          } else if (response.data.code == "1") {
            this.countDown = 120;
            this.countDownTimer();
            this.errorMessageVodal = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          }
        });
    },
    onChange(v) {
      this.checkcomplete = false;
    },
    onComplete(v) {
      this.finalcode = v;
      this.checkcomplete = true;
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          if (this.countDown > 0) {
            this.countDown -= 1;
            this.countDownTimer();
          }
        }, 1000);
      }
    }
  }
};
</script>